import { TableSchema } from '../metadata-schema';

export const dim_per_periode: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_per_periode",
	"description": "Definitie voor dimension tabel dim_per_periode uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"per_abb_kwartaal": {
			"type": "string",
			"label": "Kwartaal",
			"category": "Datum",
			"example": "1, 2, 3, 4",
			"description": "Het volgnummer van het kwartaal van deze datum in het kalenderjaar, gebaseerd op de maand.\nRespectievelijk zijn dit: jan-mrt, apr-jun, jul-sep, okt-dec."
		},
		"per_abb_weekdag": {
			"type": "string",
			"enum": [
				"ma",
				"di",
				"wo",
				"do",
				"vr",
				"za",
				"zo"
			],
			"label": "Weekdag",
			"category": "Datum",
			"example": "ma, di, wo, do, vr",
			"description": "De afgekorte weekdag van deze datum (ma t/m vr)."
		},
		"per_d_datum": {
			"type": "string",
			"format": "date",
			"label": "Datum",
			"category": "Datum",
			"example": "21-04-2023, ...",
			"description": "De volledige datum.\nIn exports wordt dit veld standaard weergegeven als dd-mm-jjjj, maar in Excel kan de datumnotatie worden aangepast."
		},
		"per_is_vakantie_midden": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Vakantie midden",
			"category": "Datum",
			"example": "Ja, Nee",
			"description": "Geeft aan of deze datum in een officiële vakantieperiode van regio Midden (Zuid-Holland, Utrecht, Gelderland) valt."
		},
		"per_is_vakantie_noord": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Vakantie noord",
			"category": "Datum",
			"example": "Ja, Nee",
			"description": "Geeft aan of deze datum in een officiële vakantieperiode van regio Noord (Noord-Holland, Flevoland, Friesland, Groningen, Drenthe, Overijssel) valt."
		},
		"per_is_vakantie_zuid": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Vakantie zuid",
			"category": "Datum",
			"example": "Ja, Nee",
			"description": "Geeft aan of deze datum in een officiële vakantieperiode van regio Zuid (Zeeland, Noord-Brabant, Limburg) valt."
		},
		"per_is_weekend": {
			"type": "integer",
			"minimum": 0,
			"maximum": 1,
			"label": "Weekend",
			"category": "Datum",
			"example": "Ja, Nee",
			"description": "Geeft aan of deze datum in het weekend valt."
		},
		"per_nm_schooljaar": {
			"type": "string",
			"label": "Schooljaar",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"example": "2022/2023, ...",
			"description": "Het schooljaar waar deze datum in valt. Een schooljaar loopt van 1 augustus tot en met 31 juli van het jaar daarna."
		},
		"per_nr_dag": {
			"type": "integer",
			"minimum": 1,
			"maximum": 31,
			"label": "Dag van de maand",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "1-31",
			"description": "De dag van de maand van deze datum."
		},
		"per_nr_datum": {
			"type": "integer",
			"label": "Datum (numeriek)",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "20230421",
			"description": "Numerieke weergave van deze datum, berekend met 10000 * jaar + 100 * maand + dag."
		},
		"per_nr_isojaar": {
			"type": "integer",
			"label": "Jaar (ISO)",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "2023",
			"description": "Het kalenderjaar waar de week van dit weeknummer bij hoort. Dit is het jaar waarin de eerste donderdag van het jaar valt."
		},
		"per_nr_isoweek": {
			"type": "integer",
			"minimum": 1,
			"maximum": 53,
			"label": "Weeknummer (ISO)",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "1-53",
			"description": "Het weeknummer van deze datum. De eerste week van een kalenderjaar is de week waarin de eerste donderdag van dat jaar valt."
		},
		"per_nr_jaar": {
			"type": "integer",
			"label": "Jaar",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "2023, ...",
			"description": "Het viercijferige kalenderjaar van deze datum."
		},
		"per_nr_maand": {
			"type": "integer",
			"minimum": 1,
			"maximum": 12,
			"label": "Maand van het jaar",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "1-12",
			"description": "Het maandnummer van het jaar van deze datum, waarbij januari = 1 en december = 12."
		},
		"per_nr_periode": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"per_nr_weekdag": {
			"type": "integer",
			"minimum": 1,
			"maximum": 7,
			"label": "Weekdag (nummer)",
			"category": "Datum",
			"filter": false,
			"grouping": false,
			"example": "1-5",
			"description": "Het volgnummer van de weekdag van deze datum, waarbij maandag = 1 en zondag = 7."
		}
	}
};
